<template>
    <div>
        <template v-if="mostrarBotonesPreventa">
            <BotonesPreventa :event="event" />
        </template>
        <a
            v-else-if="event.activar_enlace_redireccion"
            class="button large-button effect-button sitecolor-content d-flex align-items-center justify-content-center"
            :href="event.enlace_redireccion"
            target="_blank"
        >
            {{ $t('partidos.comprar') }}
        </a>

        <template v-else>
            <div class="d-flex align-content-center flex-fill">
                <template v-if="productos">
                    <router-link
                        :to="getLinkTo()"
                        class="button large-button effect-button sitecolor-content d-flex align-items-center justify-content-center"
                    >
                        <span>{{ $t('eventos_productos.boton') }}</span>
                    </router-link>
                </template>
                <button v-else-if="event.status == 3" class="button large-button d-flex align-items-center justify-content-center orange-content" disabled>
                    {{ $t('partidos.aplazado') }}
                </button>
                <template v-else-if="event.venta_online_cerrada && !event.venta_online_cerrada_definitiva">
                    <button
                        class="button large-button d-flex align-items-center justify-content-center blue-content mr-2 mr-lg-0"
                        disabled
                    >
                        <div class="row btn-padding">
                            <div class="col-12 font-prox">
                                {{ $t('partidos.proximamente') }}
                            </div>
                            <div class="col-12 font-prox">
                                <Countdown v-if="event.cuenta_atras" :endDate="event.cuenta_atras" @close="recargarEventos" />
                            </div>
                        </div>
                    </button>
                    <button
                        data-cy="btn-avisame"
                        class="button large-button d-flex align-items-center justify-content-center green-content"
                        @click="showModal('recordatorio-' + event.id)"
                    >
                        {{ $t('partidos.avisame') }}
                    </button>
                    <RecordatorioModal :evento_id="event.id" @close="closeModal" />
                </template>
                <button v-else-if="ventaCerradaDefinitiva" class="button large-button d-flex align-items-center justify-content-center orange-content" disabled>
                    {{ $t('partidos.cerrado_definitivo') }}
                </button>
                <button v-else-if="ventaCerrada" class="button large-button d-flex align-items-center justify-content-center blue-content" disabled>
                    {{ $t('partidos.venta_cerrada') }}
                </button>
                <template v-else>
                    <template v-if="event.compartido">
                        <a
                            class="button large-button effect-button sitecolor-content d-flex align-items-center justify-content-center"
                            :href="event.url_evento"
                            target="_blank"
                        >
                            {{ $t('partidos.comprar') }}
                        </a>
                    </template>
                    <template v-else>
                        <div class="d-md-flex align-items-stretch flex-fill">
                            <BotonCompraNormal v-if="!event.solo_abonados" :event="event" :esLfpSga="esLfpSga" />
                            <BotonCompraAbonado 
                                v-if="event.libres_abonados && event.tiene_descuento_abonado && (esLfpSga || this.event.entradas_disponibles_abonos?.length)" 
                                :event="event"
                                :esLfpSga="esLfpSga"
                            />
                            <BotonCompraAmigoAbonado v-if="event.libres_amigo_abonado && event.amigo_abonado" :event="event" />
                            <div class="d-flex flex-fill mt-2 mt-md-0" v-if="teatro.hash === 'J1fKG9AarPuPNJ5hwY0t'">
                                <router-link 
                                    style="font-size: 16px; background: #b38b2b;"
                                    class="button effect-button d-flex align-items-center justify-content-center"                
                                    to="/experiencias"
                                >
                                    <span>Experiencias</span>
                                </router-link>
                            </div>              
                        </div>
                    </template>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
    import BotonCompraNormal from './BotonCompraNormal';
    import BotonCompraAbonado from './BotonCompraAbonado';
    import BotonesPreventa from './BotonesPreventa';
    import BotonCompraAmigoAbonado from './BotonCompraAmigoAbonado';
    import Countdown from '@/components/common/Countdown';
    import RecordatorioModal from '@/views/frontend/events/layouts/index/modals/RecordatorioModal.vue';

    export default {
        props: {
            event: {
                type: Object,
                required: true
            },
            productos: { 
                required: false, 
                default: false, 
                type: Boolean 
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            fecha_actual() {
                const fecha = new Date()
                const fecha_actual = fecha.toISOString().split('T')[0];
                const hora_actual = fecha.toTimeString().split(' ')[0];
                return `${fecha_actual} ${hora_actual}`
            },
            ventaCerradaDefinitiva() {
                const eventoTerminado = this.event.fecha_fin_evento <= this.fecha_actual || this.event.fecha_fin_sesion <= this.fecha_actual;

                if (eventoTerminado || this.event.venta_online_cerrada_definitiva) {
                    return true;
                }

                return false;
            },
            mostrarBotonesPreventa() {
                const p = this.event?.preventa
                if (!p) return false

                const userRegistrado = this.user && p.registrado_en_preventa

                if (!p.preventa_activa) return false

                if (!(p.venta_preventa_activa || p.registro_preventa_activo)) return false

                if (p.comprado_en_preventa && p.registrado_en_preventa) return false

                if (p.venta_preventa_activa) {
                    if (!p.registro_preventa_activo) {
                        if (!userRegistrado) return false
                        if (!p.puede_comprar_en_preventa) return false
                    }
                }

                return true
            },
            esLfpSga() {
                return this.event.lfp_id || this.event.sga_id;
            },
            ventaCerrada() {
                return !this.productos &&!this.esLfpSga && !this.event.entradas_disponibles?.length && !this.event.entradas_disponibles_abonos?.length;
            },
            user() {
                return this.$store.getters.getUser;
            }
        },
        methods: {
            recargarEventos() {
                this.$emit('recargar');
            },
            showModal(modal) { 
                this.$modal.show(modal); 
            },
            closeModal(modal) { 
                this.$modal.hide(modal); 
            },
            getLinkTo() {
                if (this.event?.sesiones?.length === 1) {
                    return {
                        name: 'front.productos.show',
                        params: {
                            slug: this.event.slug,
                            sesion_id: this.event.sesiones[0].id,
                        }
                    };
                }
                return {
                    name: 'front.productos.sesiones',
                    params: {
                        slug: this.event.slug,
                    }
                };
            }
        },
        components: {
            BotonCompraNormal, BotonCompraAbonado, BotonesPreventa, BotonCompraAmigoAbonado,
            Countdown, RecordatorioModal
        }
    }
</script>

<style scoped>
    .font-prox {
        font-size: 13px !important;
    }
    .btn-padding {
        padding: 20px;
    }
</style>
